import { Routes } from '@angular/router';
import { ShiveRoutes } from '../segments/route-segments';
import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';
import { UserProfileAttachmentsComponent } from '../../../pages/user/user-profile/user-profile-attachments/user-profile-attachments.component';
import { UserProfileDataComponent } from '../../../pages/user/user-profile/user-profile-data/user-profile-data.component';

export const UserProfileRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ShiveRoutes.Edit,
  },
  {
    path: `${ShiveRoutes.Edit + UrlSegmentDelimiter}:id`,
    component: UserProfileDataComponent,
  },
  {
    path: `${ShiveRoutes.Attachments + UrlSegmentDelimiter}:id`,
    component: UserProfileAttachmentsComponent,
  },
];
